import React from 'react';

import styles from './CartNotAvailableProducts.module.css'
import {warningSignIcon} from "../../../../../../assets/icons/icons.ts";

interface Props {
    productsNotAvailableCount: number,
    showWarning: boolean,
}

export const CartNotAvailableProducts: React.FC<Props> = ({productsNotAvailableCount, showWarning}) => {
    return (
        0 !== productsNotAvailableCount 
        ? (
            <div style={{marginBottom: 16,}}>
                <h3 className={styles.title}>
                    Товаров недоступных для заказа: {productsNotAvailableCount}
                </h3>
                {
                    showWarning
                    ? <div className={styles.warning}>
                        <img src={warningSignIcon} alt='Предупреждение'/>
                        Эти предложения закончились, вы можете найти новые или подобрать аналоги
                    </div>
                    : null
                }
            </div>
        )
        : null
    );
};